export default {
    // Header
    brand: 'PlayCatGames',
    nav: {
        home: '홈',
        games: '게임',
        categories: '카테고리',
        about: '소개'
    },
    search: {
        placeholder: '고양이 게임 검색...'
    },

    // Hero Section
    hero: {
        title: '고양이 게임',
        description: 'PlayCatGames의 고양이 게임을 통해 다양하고 재미있고 영리한 방법으로 가상 고양이와 놀고, 돌보고, 상호작용할 수 있습니다. 화면에 장난감을 던지거나, 캐릭터에 의상을 드래그 앤 드롭하거나, 빠른 반사신경으로 물고기를 잡고 보상을 쫓을 수 있습니다.',
        subtitle: '일부 고양이 게임은 점프, 달리기, 등반할 때의 타이밍을 테스트하고, 다른 게임들은 먹이주기, 그루밍, 탭하여 점수 획득과 같은 간단한 동작에 중점을 둡니다. 모든 타이틀은 브라우저에서 즉시 재미를 위해 설계되었습니다. 설치 없음, 다운로드 없음, 그냥 야옹!',
        buttons: {
            start: '게임 시작',
            browse: '카테고리 둘러보기'
        },
        stats: {
            games: '무료 게임',
            categories: '게임 카테고리',
            free: '무료 체험',
            available: '항상 이용 가능'
        }
    },

    // Games Section
    games: {
        title: '인기 고양이 게임',
        subtitle: '모든 연령대의 플레이어를 위한 가장 인기 있는 무료 온라인 고양이 게임을 발견하세요',
        filters: {
            all: '전체',
            dressUp: '드레스업',
            care: '케어',
            puzzle: '퍼즐',
            arcade: '아케이드',
            simulation: '시뮬레이션'
        },
        loadMore: '더 많은 게임 로드',
        gameCategories: {
            arcade: '아케이드',
            simulation: '시뮬레이션',
            care: '케어',
            puzzle: '퍼즐',
            dressUp: '드레스업'
        }
    },

    // Categories Section
    categories: {
        title: '게임 카테고리',
        subtitle: '모든 고양이 게임은 플레이어들이 가장 즐기는 활동을 중심으로 구축됩니다: 스타일링, 애완동물 돌보기, 또는 재미있는 코스 달리기',
        browse: '카테고리 둘러보기',
        featuredGames: '추천 게임',
        gameCount: '게임',
        types: {
            dressUp: {
                name: '고양이 드레스업 게임',
                description: '고양이 드레스업 게임으로 창의력을 마음껏 발휘하세요. 의상을 믹스하고, 액세서리를 추가하고, 판타지 세트부터 계절 장비까지 테마 룩을 해제하세요.'
            },
            simulation: {
                name: '고양이 시뮬레이션 & 롤플레이',
                description: '시뮬레이터 게임에서는 고양이의 발걸음을 따라갑니다. 돌아다니고, 탐험하고, 호기심 많은 새끼 고양이의 삶을 살아보세요.'
            },
            puzzle: {
                name: '고양이 관리 & 퍼즐 게임',
                description: '전략 팬들을 위해 고양이 퍼즐과 관리 게임은 영리한 반전을 제공합니다. 여러 고양이의 균형을 맞추고, 까다로운 쌓기 도전을 해결하세요.'
            },
            arcade: {
                name: '고양이 아케이드 & 액션 게임',
                description: '반사신경과 민첩성을 테스트하는 빠른 속도의 고양이 아케이드 게임. 점프하고, 달리고, 잡고, 스릴 넘치는 게임 경험을 즐기세요.'
            }
        },
        additional: {
            title: '더 많은 고양이 게임 유형 탐색',
            description: '우리의 고양이 게임 컬렉션은 모든 기분과 선호도를 다룹니다: 패션 플레이, 애완동물 돌보기, 까다로운 퍼즐, 또는 재미있는 아케이드 런. 우리의 브라우저 기반 고양이 게임은 무료이고 안전하며 몇 초 안에 플레이할 준비가 됩니다.',
            motto: '게임을 선택하고, 시작을 탭하고, 재미가 생생하게 야옹하게 하세요!'
        }
    },

    // About Section
    about: {
        title: 'PlayCatGames 소개',
        description: [
            'PlayCatGames는 고양이 게임의 멋진 세계를 탐험하기 위한 궁극적인 목적지입니다. 우리는 모든 연령대의 플레이어에게 적합한 무료 온라인 고양이 테마 게임 컬렉션을 신중하게 큐레이션했습니다.',
            '귀여운 드레스업 게임부터 흥미진진한 아케이드 어드벤처, 따뜻한 케어 시뮬레이션부터 영리한 퍼즐 도전까지, 우리의 게임 컬렉션은 고양이 애호가들이 원할 수 있는 모든 것을 다룹니다. 모든 게임은 최고의 게임 경험을 보장하기 위해 신중하게 선택되었습니다.',
            '우리는 게임이 즉시적이고, 재미있고, 쉽게 접근할 수 있어야 한다고 믿습니다. 그래서 우리의 모든 게임은 소프트웨어를 다운로드하거나 설치하지 않고도 브라우저에서 직접 실행할 수 있습니다. 클릭하고 플레이를 시작하세요!'
        ],
        features: {
            free: '100% 무료 게임',
            mobile: '모바일 친화적',
            instant: '즉시 플레이',
            safe: '안전하고 보안'
        },
        faq: {
            title: '자주 묻는 질문',
            questions: {
                free: {
                    q: '이 게임들이 정말 무료인가요?',
                    a: '네! 우리의 모든 고양이 게임은 완전히 무료입니다. 모든 게임 콘텐츠를 즐기기 위해 아무것도 지불할 필요가 없습니다.'
                },
                download: {
                    q: '소프트웨어를 다운로드해야 하나요?',
                    a: '아니요! 모든 게임은 브라우저에서 직접 실행할 수 있습니다. 게임을 클릭하기만 하면 플레이를 시작할 수 있으며, 다운로드나 설치가 필요하지 않습니다.'
                },
                age: {
                    q: '이 게임들은 어떤 연령대에 적합한가요?',
                    a: '우리의 고양이 게임은 모든 연령대의 플레이어에게 적합합니다. 간단한 드레스업 게임부터 도전적인 퍼즐 게임까지, 모든 사람이 자신에게 맞는 게임을 찾을 수 있습니다.'
                },
                mobile: {
                    q: '게임이 모바일 기기를 지원하나요?',
                    a: '네! 우리의 모든 게임은 PC, 태블릿, 스마트폰에서 완벽하게 실행되도록 최적화되어 있습니다. 언제 어디서나 게임의 재미를 즐길 수 있습니다.'
                },
                updates: {
                    q: '새로운 게임을 추가할 예정인가요?',
                    a: '물론입니다! 우리는 정기적으로 게임 라이브러리를 업데이트하고 새로운 흥미로운 고양이 게임을 추가합니다. 최신 게임 콘텐츠를 확인하기 위해 자주 돌아와 주세요.'
                }
            }
        }
    },

    // Footer
    footer: {
        description: '당신의 무료 온라인 고양이 게임 컬렉션 목적지. 수십 개의 흥미진진한 고양이 테마 게임을 발견하고, 플레이하고, 즐기세요.',
        quickLinks: '빠른 링크',
        gameCategories: '게임 카테고리',
        support: '지원',
        links: {
            popularGames: '인기 게임',
            latestGames: '최신 게임',
            recommendedGames: '추천 게임',
            faq: '자주 묻는 질문',
            contact: '문의하기',
            feedback: '피드백',
            privacy: '개인정보처리방침',
            terms: '이용약관',
            cookies: '쿠키 정책',
            sitemap: '사이트맵'
        },
        copyright: '모든 권리 보유.',
        disclaimer: '모든 게임 콘텐츠는 오락 및 교육 목적으로만 인터넷에서 조달됩니다. 저작권 문제가 있으면 문의해 주세요.',
        backToTop: '맨 위로',
        friendlyLinks: '친구 사이트'
    },

    // Game Data
    gameData: {
        descriptions: {
            kittyLovesBirds: '새끼 고양이가 날아다니는 새를 잡도록 도와주고 반응 속도를 보여주세요',
            catPizza: '고양이 피자 가게를 운영하고 고객을 위해 맛있는 피자를 만드세요',
            funnyKittyCare: '귀여운 새끼 고양이를 돌보고, 먹이를 주고, 목욕시키고, 놀아주세요',
            catsDrop: '균형과 전략 기술을 테스트하는 고양이 쌓기 게임',
            catpad: '귀여운 고양이 플랫폼 점프 게임',
            funnyKittyDressup: '다양한 옷과 액세서리로 귀여운 새끼 고양이를 드레스업',
            kittyCats: '여러 귀여운 고양이와 상호작용하는 캐주얼 게임',
            dualCat: '두 마리 고양이를 동시에 조작하는 도전 게임',
            funnyKittyHaircut: '새끼 고양이를 위한 패셔너블한 헤어스타일을 디자인하는 미용 게임',
            catCoffeeShop: '고양이 카페를 운영하고 맛있는 음료를 만드세요'
        },
        categories: {
            puzzle: '퍼즐',
            simulation: '시뮬레이션',
            casual: '캐주얼',
            action: '액션',
            adventure: '어드벤처',
            strategy: '전략',
            sports: '스포츠',
            racing: '레이싱',
            dressup: '드레스업',
            care: '케어'
        },
        tags: {
            cute: '귀여운',
            anime: '애니메',
            dark: '다크',
            funny: '재미있는',
            educational: '교육적',
            multiplayer: '멀티플레이어',
            relaxing: '편안한',
            challenging: '도전적인',
            colorful: '다채로운',
            simple: '간단한',
            complex: '복잡한',
            family: '가족 친화적',
            kids: '아이들',
            adult: '성인'
        }
    },

    // Common
    common: {
        loading: '로딩 중...',
        error: '문제가 발생했습니다',
        retry: '다시 시도',
        play: '게임 플레이',
        language: '언어',
        backToHome: '홈으로 돌아가기'
    },

    // Legal Pages (simplified)
    legal: {
        privacy: {
            title: '개인정보처리방침',
            lastUpdated: '최종 업데이트'
        },
        terms: {
            title: '이용약관',
            lastUpdated: '최종 업데이트'
        },
        cookies: {
            title: '쿠키 정책',
            lastUpdated: '최종 업데이트'
        }
    },

    // Sitemap
    sitemap: {
        title: '사이트맵',
        description: 'PlayCatGames 웹사이트의 모든 페이지와 콘텐츠 찾기'
    }
}